var _dimtools = this;
this.dimensionsViewToFull = (objDims, container) => {
  var el = document.getElementById(container);
  if(el){
    var viewportContainerOffset = el.getBoundingClientRect();
    var currentWidth = viewportContainerOffset.width;
    var ratio = 1920/currentWidth;
    _dimtools.dimensionsToRatio(objDims, ratio);
  }    
}
this.dimensionsFullToView = (objDims, container) => {
  var el = document.getElementById(container)
  if(el){
    var viewportContainerOffset = el.getBoundingClientRect();
    var currentWidth = viewportContainerOffset.width;
    var ratio = currentWidth/1920;
    _dimtools.dimensionsToRatio(objDims, ratio);
  }    
}
this.dimFullToView = (objDim, container) => {
  var el = document.getElementById(container)
  if(el){
    var viewportContainerOffset = el.getBoundingClientRect();
    var currentWidth = viewportContainerOffset.width;
    var ratio = currentWidth/1920;
    return objDim*ratio;
  }
  return objDim; 
}
this.dimensionsToRatio = (objDims, ratio) => {
    var dimsKeys = Object.keys(objDims);
    for(var dimIndex in dimsKeys){
      var dimName = dimsKeys[dimIndex];
      objDims[dimName] = objDims[dimName]*ratio; 
    }
  }

  export default{
      name: 'Dimtools',
      dimensionsFullToView: this.dimensionsFullToView,
      dimensionsViewToFull: this.dimensionsViewToFull,
      dimFullToView: this.dimFullToView,
      dimensionsToRatio: this.dimensionsToRatio
  }



// WEBPACK FOOTER //
// ./C:/Git/adventify-vuefire/src/components/DimTools.js